export const apiURL=import.meta.env.VITE_DOC_APP_API_URL;
